import { SEWAGE_FIXTURE_UNITS } from "../../data/gpm";
import { GpmData, PumpSizingFormData, SewageFixtureUnitValues } from "../../types/types";
import { parseNumericValue } from "./helpers";

export function calculateTotalFixtureUnits(
	fixtureUnits: SewageFixtureUnitValues,
): number {
	return SEWAGE_FIXTURE_UNITS.reduce((total, fixture) => {
		const count = parseNumericValue(fixtureUnits[fixture.id], 0);
		return total + count * fixture.multiplier;
	}, 0);
}

export function getGpmDisplayValue(formData: PumpSizingFormData): string {
	const { applicationType, gpmData } = formData;

	if (applicationType === "email" || gpmData.mode === "known") {
		return gpmData.knownGpm.trim();
	}

	return gpmData.calculatedGpm.trim();
}

export function isGpmStepValid(formData: PumpSizingFormData): boolean {
	const { applicationType, gpmData } = formData;

	if (!applicationType) {
		return false;
	}

	if (gpmData.mode === "known") {
		return gpmData.knownGpm.trim() !== "";
	}

	switch (applicationType) {
		case "sump":
			return isSumpHelpValid(gpmData);
		case "septic":
			return isSepticHelpValid(gpmData);
		case "sewage":
			return gpmData.sewage.totalFixtureUnits > 0;
		case "email":
			return gpmData.knownGpm.trim() !== "";
		default:
			return false;
	}
}

function isSumpHelpValid(gpmData: GpmData): boolean {
	const { sump } = gpmData;

	if (!sump.drainageType) {
		return false;
	}

	const hasArea =
		sump.areaMode === "dimensions"
			? sump.length.trim() !== "" && sump.width.trim() !== ""
			: sump.areaSqft.trim() !== "";

	if (!hasArea) {
		return false;
	}

	if (sump.manualRainfall) {
		return sump.rainfall.trim() !== "";
	}
	return /^\d{5}$/.test(sump.zipCode.trim());
}

function isSepticHelpValid(gpmData: GpmData): boolean {
	const { septic } = gpmData;

	if (!septic.systemType) {
		return false;
	}

	if (septic.systemType === "conventional") {
		return septic.pipeDiameter !== "";
	}

	return (
		septic.distalPressure.trim() !== "" &&
		septic.totalLaterals.trim() !== "" &&
		septic.orificesPerLateral.trim() !== "" &&
		septic.orificeFraction !== ""
	);
}
